var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_1905)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8028_1905",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8028_1905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_8028_1905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8281 16.8126H8.71875C7.72234 16.8126 6.79484 16.4689 6.10715 15.8443C5.3932 15.196 5 14.297 5 13.3126C5 12.3123 5.36613 11.4499 6.05875 10.8183C6.60371 10.3209 7.34719 9.98262 8.17461 9.85109C8.43319 9.17615 8.85859 8.57775 9.41109 8.11176C10.1341 7.50719 11.0293 7.18754 12 7.18754C13.0919 7.18279 14.1427 7.60355 14.9296 8.36059C15.6695 9.07316 16.1489 10.0363 16.3271 11.1623C17.6755 11.3619 19 12.2776 19 13.9688C19 14.8818 18.6653 15.6308 18.0318 16.1353C17.475 16.5782 16.7132 16.8126 15.8281 16.8126Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8028_1905",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_1905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudEdge);
export default __webpack_public_path__ + "static/media/Cloud-Edge.8fea06c1d063ff80a03ca8e7f6661113.svg";
export { ForwardRef as ReactComponent };